<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 时间范围选择 -->
            <div class="block" style="margin-right: 20px;">
              <el-date-picker
                  size="mini"
                  v-model="queryParams.timeRange"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="handleDateRangeChange"
                  value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>

            <!-- 按钮组 -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table" style="margin-top: 16px; padding: 0 10px;">
          <el-table
              :data="tableData"
              border
              v-loading="tableLoading"
              style="width: 100%"
              row-key="id"
              :row-class-name="getRowClassName">
            <el-table-column fixed="left" label="行号" type="index" width="60" align="center"></el-table-column>

            <el-table-column
                v-for="(col, inx) in tableRows1"
                :key="inx"
                :prop="col.prop"
                :label="col.name"
                :min-width="getColumnWidth(col.name, col.prop, tableData)"
                header-align="center"
                align="center">
              <template #default="{ row }">
                <template v-if="col.prop === 'amount'">
                  <span :style="{ color: row.amount > 0 ? '#67c23a' : '#f56c6c', fontWeight: 'bold' }">
                    {{ formatMoney(Math.abs(row.amount)) }}
                    <span style="font-size: 12px;">{{ row.amount > 0 ? '(转入)' : '(转出)' }}</span>
                  </span>
                </template>
                <template v-else-if="col.prop === 'type'">
                  <el-tag :type="getTypeTagType(row.type)" size="small">
                    {{ getTypeLabel(row.type) }}
                  </el-tag>
                </template>
                <template v-else-if="col.prop === 'classId'">
                  {{ getFinanceClassName(row.classId) }}
                </template>
                <template v-else>
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </template>
            </el-table-column>
          </el-table>

        </div>

        <!-- 转账对话框 -->
        <el-dialog
            title="存取转账单"
            :visible.sync="transferDialogVisible"
            :close-on-click-modal="false"
            width="600px"
            @close="handleCloseTransfer"
            class="custom-form-dialog"
        >
          <el-form
              size="mini"
              :model="transferForm"
              ref="transferForm"
              :rules="transferFormRules"
              label-width="150px"
              label-position="right"
          >
            <!-- 转出财务分类 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="转出财务分类:" prop="outClassId">
                  <el-cascader
                      v-model="transferForm.outClassId"
                      :options="processedFinanceClassOptions"
                      :props="cascaderProps"
                      style="width: 100%"
                      clearable
                      filterable
                      @change="handleOutClassChange"
                      :show-all-levels="false"
                      :disabled="financeClassLoading"
                      placeholder="请选择转出账户"
                  >
                    <template slot-scope="{ node, data }">
                      <span :class="{ 'disabled-text': data.disableCheckbox }">{{ data.label }}</span>
                      <span v-if="data.type" style="margin-left: 8px;">
                        <el-tag
                            :type="getFinanceClassTagType(data.type)"
                            size="mini"
                            effect="plain"
                            :disable-transitions="data.disableCheckbox"
                        >
                          {{ getFinanceClassTypeText(data.type) }}
                        </el-tag>
                      </span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 转入财务分类 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="转入财务分类:" prop="inClassId">
                  <el-cascader
                      v-model="transferForm.inClassId"
                      :options="processedFinanceClassOptions"
                      :props="cascaderProps"
                      style="width: 100%"
                      clearable
                      filterable
                      @change="handleInClassChange"
                      :show-all-levels="false"
                      :disabled="financeClassLoading"
                      placeholder="请选择转入账户"
                  >
                    <template slot-scope="{ node, data }">
                      <span :class="{ 'disabled-text': data.disableCheckbox }">{{ data.label }}</span>
                      <span v-if="data.type" style="margin-left: 8px;">
                        <el-tag
                            :type="getFinanceClassTagType(data.type)"
                            size="mini"
                            effect="plain"
                            :disable-transitions="data.disableCheckbox"
                        >
                          {{ getFinanceClassTypeText(data.type) }}
                        </el-tag>
                      </span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 转账金额 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="金额:" prop="amount">
                  <el-input-number
                      v-model="transferForm.amount"
                      :min="0.01"
                      :precision="2"
                      controls-position="right"
                      style="width: 100%"
                      placeholder="请输入转账金额"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 备注 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="备注:" prop="remark">
                  <el-input
                      v-model="transferForm.remark"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入备注信息"
                      maxlength="200"
                      show-word-limit
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="handleTransfer">确认转账</el-button>
            <el-button size="mini" @click="handleCloseTransfer">取消</el-button>
          </div>
        </el-dialog>

      </div>
    </div>

    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>

<script>
import {withLoading} from "@/untils/loading";
import {getAllFinanceclass} from "@/api/clasificacionContable/clasificacionContable";
import {getFinancialDetailsPage} from "@/api/financialDetails/financialDetails";
import {
  docClinicFundList,
  docclinicFundList,
  financialCategoryTransfer
} from "@/api/FinancialCategoryTransfer/FinancialCategoryTransfer";

export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      // 需要禁用复选框的节点ID列表（父节点不可选，子节点可选）
      disabledCheckboxIds: [102, 115], // 银行账号(102)、聚合支付(115)

      // 级联选择器相关
      financeClassOptions: [],
      processedFinanceClassOptions: [], // 处理后的数据（带禁用标识）
      financeClassLoading: false,
      financeClassMap: {}, // 财务分类ID到名称的映射

      CatalogueName: '存取转账单',
      iconComes: 'el-icon-refresh',

      // 查询参数
      queryParams: {
        orderNo: '',
        timeRange: [],
        startTime: '',
        endTime: ''
      },

      // 模态框控制
      loading: false,
      tableLoading: false,
      transferDialogVisible: false,

      // 分页参数
      pageNum: 1,
      pageSize: 8,
      totalSize: 0,

      // 转账表单
      transferForm: {
        outClassId: null,
        inClassId: null,
        amount: null,
        remark: ''
      },

      // 表单验证规则
      transferFormRules: {
        outClassId: [
          { required: true, message: '请选择转出财务分类', trigger: 'change' }
        ],
        inClassId: [
          { required: true, message: '请选择转入财务分类', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value && this.transferForm.outClassId === value) {
                callback(new Error('转入和转出分类不能相同'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        amount: [
          { required: true, message: '请输入转账金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '金额必须大于0', trigger: 'blur' }
        ]
      },

      cascaderProps: {
        value: 'id',
        label: 'label',
        children: 'children',
        checkStrictly: true,
        emitPath: false,
        expandTrigger: 'hover'
      },

      // 表格数据
      tableData: [],
      groupedData: [],

      // 表格列配置
      tableRows1: [
        {prop: "orderNo", name: "订单号"},
        {prop: "type", name: "单据类型"},
        {prop: "classId", name: "财务分类"},
        {prop: "amount", name: "金额"},
        {prop: "createName", name: "经手人"},
        {prop: "createTime", name: "创建时间"},
      ],

      // 单据类型选项
      typeOptions: [
        {id: 1, label: '挂号'},
        {id: 2, label: '门诊收费'},
        {id: 3, label: '其他收费'},
        {id: 4, label: '一般费用'},
        {id: 5, label: '付款单'},
        {id: 6, label: '期初'},
        {id: 7, label: '财务转账'}
      ],

      // 动态按钮
      headerBtn: [
        { search: "search", title: "搜索", type: "success", style: { marginLeft: "-20px" } },
        { transfer: "transfer", title: "新增", type: "warning"},
      ],
    };
  },
  async mounted() {
    await this.loadFinanceClassData();
    await this.loadData();
    await this.getDocClinicFundList();
  },
  methods: {
    async  getDocClinicFundList(){
      const  res = await   docClinicFundList();
      console.log(res,'docClinicFundListdocClinicFundListdocClinicFundList')
    },
    // 加载财务分类数据
    async loadFinanceClassData() {
      try {
        this.financeClassLoading = true;
        const res = await getAllFinanceclass();
        console.log('财务分类数据:', res);

        if (res && res.children) {
          // 查找资金账户节点(id=100)
          const fundAccountNode = this.findNodeById(res.children, 100);

          if (fundAccountNode) {
            // 处理节点，添加禁用标识
            this.financeClassOptions = [this.processNode(fundAccountNode)];
            // 处理带禁用标识的数据用于显示
            this.processedFinanceClassOptions = this.addDisableCheckbox([this.processNode(fundAccountNode)]);
            // 构建ID到名称的映射
            this.buildFinanceClassMap(fundAccountNode);
          } else {
            this.financeClassOptions = this.processFinanceClassForCascader(res.children);
            this.processedFinanceClassOptions = this.addDisableCheckbox(this.financeClassOptions);
            this.buildFinanceClassMap(res);
          }
        }
        console.log('处理后的财务分类选项:', this.processedFinanceClassOptions);
        console.log('财务分类映射:', this.financeClassMap);
      } catch (error) {
        console.error('加载财务分类失败:', error);
        this.$message.error('加载财务分类失败');
      } finally {
        this.financeClassLoading = false;
      }
    },

    // 递归添加禁用复选框标识
    addDisableCheckbox(nodes) {
      if (!nodes || !Array.isArray(nodes)) return [];

      return nodes.map(node => {
        const newNode = { ...node };

        // 如果当前节点ID在禁用列表中，添加 disableCheckbox 属性
        if (this.disabledCheckboxIds.includes(node.id)) {
          newNode.disableCheckbox = true;
        }

        // 递归处理子节点
        if (node.children && node.children.length > 0) {
          newNode.children = this.addDisableCheckbox(node.children);
        }

        return newNode;
      });
    },

    // 构建财务分类ID到名称的映射
    buildFinanceClassMap(node) {
      const traverse = (n) => {
        if (n.id && n.label) {
          this.financeClassMap[n.id] = n.label;
        }
        if (n.children && n.children.length > 0) {
          n.children.forEach(child => traverse(child));
        }
      };
      traverse(node);
    },

    // 根据ID获取财务分类名称
    getFinanceClassName(id) {
      return this.financeClassMap[id] || `分类${id}`;
    },

    // 根据ID查找节点
    findNodeById(nodes, targetId) {
      if (!nodes || !Array.isArray(nodes)) return null;
      for (const node of nodes) {
        if (node.id === targetId) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodeById(node.children, targetId);
          if (found) return found;
        }
      }
      return null;
    },

    // 处理单个节点
    processNode(node) {
      const cascaderNode = {
        id: node.id,
        label: node.label || node.name || node.text || '',
        type: node.type || 3,
        value: node.id,
        children: []
      };

      if (node.children && node.children.length > 0) {
        cascaderNode.children = node.children.map(child => this.processNode(child));
      }

      return cascaderNode;
    },

    // 处理财务分类数据为级联格式
    processFinanceClassForCascader(nodes) {
      const typeOrder = { 1: 1, 2: 2, 3: 3 };

      const sortedNodes = [...nodes].sort((a, b) => {
        const orderA = typeOrder[a.type] || 4;
        const orderB = typeOrder[b.type] || 4;
        if (orderA !== orderB) return orderA - orderB;
        return (a.order || 0) - (b.order || 0);
      });

      const processNode = (node) => {
        const cascaderNode = {
          id: node.id,
          label: node.label || node.name || node.text || '',
          type: node.type || 1,
          value: node.id,
          children: []
        };

        if (node.children && node.children.length > 0) {
          const sortedChildren = [...node.children].sort((a, b) => {
            const orderA = typeOrder[a.type] || 4;
            const orderB = typeOrder[b.type] || 4;
            if (orderA !== orderB) return orderA - orderB;
            return (a.order || 0) - (b.order || 0);
          });
          cascaderNode.children = sortedChildren.map(child => processNode(child));
        }

        return cascaderNode;
      };

      return sortedNodes.map(node => processNode(node));
    },

    // 获取财务分类标签类型
    getFinanceClassTagType(type) {
      switch (type) {
        case 1: return 'success';
        case 2: return 'danger';
        case 3: return 'primary';
        default: return 'info';
      }
    },

    // 获取财务分类类型文本
    getFinanceClassTypeText(type) {
      switch (type) {
        case 1: return '收入';
        case 2: return '支出';
        case 3: return '资金';
        case 4: return '资产';
        case 5: return '负债';
        default: return '未知';
      }
    },

    // 获取单据类型标签样式
    getTypeTagType(type) {
      const typeMap = {
        1: 'success',
        2: 'primary',
        3: 'info',
        4: 'warning',
        5: 'danger',
        6: '',
        7: 'success'
      };
      return typeMap[type] || 'info';
    },

    // 获取单据类型标签文本
    getTypeLabel(type) {
      const option = this.typeOptions.find(item => item.id === type);
      return option ? option.label : '-';
    },

    // 获取行样式（相同订单号背景色相同）
    getRowClassName({row}) {
      if (row.orderNo) {
        const hash = this.hashString(row.orderNo);
        return `order-group-color-${hash % 6}`;
      }
      return '';
    },

    // 生成哈希值
    hashString(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    },

    // 分组汇总数据
    groupTransferData(data) {
      const groupMap = new Map();

      data.forEach(item => {
        if (!groupMap.has(item.orderNo)) {
          groupMap.set(item.orderNo, {
            orderNo: item.orderNo,
            items: [],
            totalAmount: 0,
            outAccount: '',
            inAccount: '',
            createTime: item.createTime
          });
        }

        const group = groupMap.get(item.orderNo);
        group.items.push(item);

        if (item.amount < 0) {
          group.totalAmount += Math.abs(item.amount);
          group.outAccount = this.getFinanceClassName(item.classId);
        } else if (item.amount > 0) {
          group.inAccount = this.getFinanceClassName(item.classId);
        }
      });

      return Array.from(groupMap.values());
    },

    // 转出分类变化 - 检查是否选中了禁用的节点
    handleOutClassChange(value) {
      console.log('转出分类:', value);
      // 检查选中的值是否是被禁用的节点
      if (value !== null && this.disabledCheckboxIds.includes(value)) {
        this.$message.warning('银行账号和聚合支付不能直接选择，请选择其下的具体账户');
        this.transferForm.outClassId = null;
        return;
      }
      if (this.transferForm.inClassId === value) {
        this.transferForm.inClassId = null;
        this.$message.warning('转入分类不能与转出分类相同');
      }
    },

    // 转入分类变化 - 检查是否选中了禁用的节点
    handleInClassChange(value) {
      console.log('转入分类:', value);
      // 检查选中的值是否是被禁用的节点
      if (value !== null && this.disabledCheckboxIds.includes(value)) {
        this.$message.warning('银行账号和聚合支付不能直接选择，请选择其下的具体账户');
        this.transferForm.inClassId = null;
        return;
      }
    },

    // 日期范围变化
    handleDateRangeChange(value) {
      if (value && value.length === 2) {
        this.queryParams.startTime = value[0];
        this.queryParams.endTime = value[1];
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.pageNum = 1;
      this.loadData();
    },

    // 执行转账
    async handleTransfer() {
      try {
        await this.$refs.transferForm.validate();
      } catch (error) {
        this.$message.warning('请完善表单信息');
        return;
      }

      await withLoading(this, '转账处理中...')(async () => {
        const res = await financialCategoryTransfer(this.transferForm);

        if (res.code === 200) {
          this.$message.success(res.message || '转账成功');
          this.handleCloseTransfer();
          await this.loadData();
        } else {
          this.$message.error(res.message || '转账失败');
        }
      });
    },

    // 关闭转账对话框
    handleCloseTransfer() {
      this.transferForm = {
        outClassId: null,
        inClassId: null,
        amount: null,
        remark: ''
      };
      this.$nextTick(() => {
        if (this.$refs.transferForm) {
          this.$refs.transferForm.clearValidate();
        }
      });
      this.transferDialogVisible = false;
    },

    // 加载转账记录列表
    async loadData() {
      this.tableLoading = true;
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          startTime: this.queryParams.startTime || null,
          endTime: this.queryParams.endTime || null,
          type: 7,
        };

        if (this.queryParams.orderNo) {
          params.orderNo = this.queryParams.orderNo;
        }

        console.log('查询参数:', params);

        const res = await getFinancialDetailsPage(params);
        console.log('转账记录列表:', res);

        if (res.code === 200) {
          this.totalSize = res.data.totalSize || 0;
          this.tableData = res.data.content || [];
          this.groupedData = this.groupTransferData(this.tableData);
        } else {
          this.$message.error(res.message || '加载数据失败');
          this.tableData = [];
          this.totalSize = 0;
          this.groupedData = [];
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
        this.tableData = [];
        this.totalSize = 0;
        this.groupedData = [];
      } finally {
        this.tableLoading = false;
      }
    },

    // 表格字段映射
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return '-';

      if (col.prop === 'type') {
        const option = this.typeOptions.find(item => item.id === rawValue);
        return option ? option.label : rawValue;
      }

      return rawValue;
    },

    // 格式化金额
    formatMoney(value) {
      if (value === null || value === undefined || value === '') return '0.00';
      const num = parseFloat(value);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2);
    },

    // 按钮点击处理
    async handClick(i) {
      switch (i) {
        case 0: // 搜索
          this.pageNum = 1;
          await this.loadData();
          break;
        case 1: // 转账
          this.transferDialogVisible = true;
          break;
      }
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 获取列宽
    getColumnWidth(label, prop, tableData) {
      const minWidth = 100;
      const padding = 20;
      const contentList = tableData.map(item => {
        if (prop === 'type') {
          const option = this.typeOptions.find(opt => opt.id === item[prop]);
          return option ? option.label : '';
        }
        if (prop === 'classId') {
          return this.getFinanceClassName(item[prop]);
        }
        if (prop === 'amount') {
          return this.formatMoney(Math.abs(item[prop]));
        }
        return item?.[prop] ?? '';
      });
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });
      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    }
  }
}
</script>

<style lang="less" scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.table {
  padding: 0 10px;
}

// 禁用文本样式
.disabled-text {
  color: #c0c4cc;
  cursor: not-allowed;
  opacity: 0.6;
}

// 相同订单号行样式
::v-deep .order-group-color-0 td {
  background-color: #e6f7ff !important;
}
::v-deep .order-group-color-1 td {
  background-color: #f6ffed !important;
}
::v-deep .order-group-color-2 td {
  background-color: #fff7e6 !important;
}
::v-deep .order-group-color-3 td {
  background-color: #fff2f0 !important;
}
::v-deep .order-group-color-4 td {
  background-color: #f9f0ff !important;
}
::v-deep .order-group-color-5 td {
  background-color: #e6fffb !important;
}

// 级联选择器禁用复选框样式
::v-deep .el-cascader-node.is-disabled .el-radio__input {
  cursor: not-allowed;
}

::v-deep .el-cascader-node.is-disabled .el-radio__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}

// 穿透样式
/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  text-align: center;
}

/deep/ .el-table td.el-table__cell div :first-child {
  text-align: center;
}

/deep/ .el-table td.el-table__cell div {
  text-align: center;
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
}

// content
.MedicenCata {
  height: 100%;
  width: 100%;

  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto;

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;
      }
    }
  }
}
</style>